__turbopack_context__.v({
  "divider": "BadgeGroup-module-scss-module__oPK87a__divider",
  "group": "BadgeGroup-module-scss-module__oPK87a__group",
  "row": "BadgeGroup-module-scss-module__oPK87a__row",
  "rowLabel": "BadgeGroup-module-scss-module__oPK87a__rowLabel",
});
